import React, { FC } from 'react';
import { META_URLS, SITE_CONTENT } from '../../appConstants';
import { BigFeedback, BigHeader, BlockContent } from '../../components';
import styles from './styles.module.scss';
import { HelmetSeo } from '../../components/HelmetSeo/HelmetSeo';

const LinkToSite = ({ href = '' }: { href?: string }) => (
    <a href={`${SITE_CONTENT.Domain}${href}`}>{`${SITE_CONTENT.Domain}${href}`}</a>
);
const MailLink = () => (
    <a href={`mailto:${SITE_CONTENT.CeoMail}`}>{SITE_CONTENT.CeoMail}</a>
);

export const PolicyPage: FC = () => {
    window.scrollTo(0, 0);
    const { Page } = SITE_CONTENT;
    const { PolicyPage } = META_URLS;

    return (
        <>
            <HelmetSeo
                title={Page[PolicyPage].title}
                description={Page[PolicyPage].description}
            />
            <BlockContent contentClass={styles.policyPage}>
                <BigHeader className={styles.title} title="Политика конфиденциальности" />

                <h3>
                    Политика в отношении обработки персональных данных ООО «Кибер Форм
                    Системс»
                </h3>

                <p>
                    <div><b>УТВЕРЖДЕНО:</b></div>
                    <div>Приказ №001-пк от 30.10.2025 г.</div>
                    <div>Генеральный директор ООО «Кибер Форм Системс»</div>
                    <div>Е. А. Мельниченко</div>
                </p>

                <p>
                    <div>
                        <b>Содержание</b>
                    </div>
                    <div>1. Общие положения</div>
                    <div>2. Принципы обработки персональных данных</div>
                    <div>3. Правовые основания обработки персональных данных </div>
                    <div>
                        4. Объем, категории и условия обрабатываемых персональных данных,
                        категории субъектов персональных данных применительно к заявленным
                        целям обработки персональных данных
                    </div>
                    <div>5. Порядок сбора и хранения персональных данных</div>
                    <div>6. Защита персональных данных </div>
                    <div>
                        7. Актуализация, исправление, удаление и уничтожение персональных
                        данных, ответы на запросы субъектов на доступ к персональным
                        данным
                    </div>
                    <div>8. Заключение положения</div>
                </p>

                <p>
                    <b>1. ОБЩИЕ ПОЛОЖЕНИЯ</b>
                </p>
                <p>
                    <div>
                        1.1. Настоящая политика в отношении обработки персональных данных
                        (далее – «Политика») разработана во исполнение требований пункта 2
                        части 1 статьи 18.1 Федерального закона от 27.07.2006 № 152-ФЗ «О
                        персональных данных» (далее – «Закон о персональных данных») в
                        целях обеспечения защиты прав и свобод человека и гражданина при
                        обработке его персональных данных, в том числе защиты прав на
                        неприкосновенность частной жизни, личную и семейную тайну.
                    </div>
                    <div>
                        <div>
                            1.2. Настоящая Политика действует в отношении следующих
                            категорий субъектов персональных данных, которые обрабатывает
                            Оператор:
                            <div>
                                - работники Оператора и физические лица, оказывающие
                                услуги или выполняющие работы по гражданско-правовым
                                договорам, или физические лица-представители таких
                                оказывающих услуги юридических лиц (далее – исполнители);
                            </div>
                            <div>- соискатели на вакантные места Оператора;</div>
                            <div>- посетители сайта Оператора;</div>
                        </div>
                    </div>

                    <div>
                        1.3. Основные понятия, используемые в Политике:
                        <div>
                            <b>Персональные данные </b>
                            — любая информация, относящаяся к прямо или косвенно
                            определенному или определяемому физическому лицу (субъекту
                            персональных данных);
                        </div>
                        <div>
                            <b>Пользователь</b>
                            — любое физическое лицо - посетитель Сайта.
                        </div>
                        <div>
                            <b>Оператор персональных данных (Оператор)</b>
                            - ООО «Кибер Форм Системс», ОГРН 1177746982819, ИНН/КПП
                            7751076359/ 775101001, 108813, г. Москва, вн. тер. г.
                            муниципальный округ Филимонковский, г. Московский, ул.
                            Солнечная, д. 2А, стр. 2, этаж 2, ком. 210, самостоятельно или
                            совместно с другими лицами организующее и (или) осуществляющее
                            обработку персональных данных, а также определяющее цели
                            обработки персональных данных, состав персональных данных,
                            подлежащих обработке, действия (операции), совершаемые с
                            персональными данными;
                        </div>
                        <div>
                            <b>Обработка персональных данных</b>
                            - любое действие (операция) или совокупность действий (операций)
                            с персональными данными, совершаемых с использованием средств
                            автоматизации или без их использования. Обработка персональных
                            данных включает в себя в том числе: сбор, запись,
                            систематизацию, накопление, хранение, уточнение (обновление,
                            изменение), извлечение, использование, передачу
                            (распространение, предоставление, доступ), обезличивание,
                            блокирование, удаление, уничтожение;
                        </div>
                        <div>
                            <b>Автоматизированная обработка персональных данных </b>
                            – обработка персональных данных с помощью средств вычислительной
                            техники;
                        </div>
                        <div>
                            <b>Распространение персональных данных </b>
                            – действия, направленные на раскрытие персональных данных неопределенному
                            кругу лиц;
                        </div>
                        <div>
                            <b>Предоставление персональных данных </b>
                            – действия, направленные на раскрытие персональных данных определенному
                            лицу или определенному кругу лиц;
                        </div>
                        <div>
                            <b>Блокирование персональных данных </b>
                            – временное прекращение обработки персональных данных (за исключением
                            случаев, если обработка необходима для уточнения персональных
                            данных);
                        </div>
                        <div>
                            <b>Уничтожение персональных данных </b>
                            – действия, в результате которых становится невозможным восстановить
                            содержание персональных данных в информационной системе
                            персональных данных и (или) в результате которых уничтожаются
                            материальные носители персональных данных;
                        </div>
                        <div>
                            <b>Обезличивание персональных данных </b>
                            – действия, в результате которых становится невозможным без использования
                            дополнительной информации определить принадлежность
                            персональных данных конкретному субъекту персональных
                            данных;
                        </div>
                        <div>
                            <b>Информационная система персональных данных </b>
                            – совокупность содержащихся в базах данных персональных данных и
                            обеспечивающих их обработку информационных технологий и
                            технических средств;
                        </div>
                        <div>
                            <b>Трансграничная передача персональных данных </b>
                            – передача персональных данных на территорию иностранного государства
                            органу власти иностранного государства, иностранному
                            физическому лицу или иностранному юридическому лицу;
                        </div>
                        <div>
                            <b>Сайт </b>
                            – совокупность программ для электронных
                            вычислительных машин и иной информации, содержащейся в
                            информационной системе, доступ к которой обеспечивается
                            посредством информационно-телекоммуникационной сети интернет и
                            расположенной по адресу:
                            {' '}
                            <LinkToSite />
                            .
                        </div>
                    </div>
                    <div>
                        1.4. Основные права и обязанности Оператора.
                        <div>1.4.1. Оператор имеет право:</div>
                        <div>
                            - самостоятельно определять состав и перечень мер, необходимых
                            и достаточных для обеспечения выполнения обязанностей,
                            предусмотренных Законом о персональных данных и принятыми в
                            соответствии с ним нормативными правовыми актами, если иное не
                            предусмотрено Законом о персональных данных или другими
                            федеральными законами;
                        </div>
                        <div>
                            - поручить обработку персональных данных другому лицу с
                            согласия субъекта персональных данных, если иное не
                            предусмотрено федеральным законом, на основании заключаемого с
                            этим лицом договора. Лицо, осуществляющее обработку
                            персональных данных по поручению Оператора, обязано соблюдать
                            принципы и правила обработки персональных данных,
                            предусмотренные Законом о персональных данных;
                        </div>
                        <div>
                            - в случае отзыва субъектом персональных данных согласия на
                            обработку персональных данных Оператор вправе продолжить
                            обработку персональных данных без согласия субъекта
                            персональных данных при наличии оснований, указанных в Законе
                            о персональных данных.
                        </div>
                        <div>1.4.2. Оператор обязан:</div>
                        <div>
                            - организовывать обработку персональных данных в соответствии
                            с требованиями Закона о персональных данных;
                        </div>
                        <div>
                            - отвечать на обращения и запросы субъектов персональных
                            данных и их законных представителей в соответствии с
                            требованиями Закона о персональных данных;
                        </div>
                        <div>
                            - сообщать в уполномоченный орган по защите прав субъектов
                            персональных данных (далее – «Роскомнадзор») по запросу этого
                            органа необходимую информацию в течение 10 рабочих дней с даты
                            получения такого запроса.
                        </div>
                        <div>
                            1.5. Основные права Субъектов персональных данных. Субъект
                            персональных данных имеет право:
                        </div>
                        <div>
                            - получать информацию, касающуюся обработки его персональных
                            данных, за исключением случаев, предусмотренных федеральными
                            законами. Сведения предоставляются Субъекту персональных
                            данных Оператором в доступной форме, и в них не должны
                            содержаться персональные данные, относящиеся к другим
                            Субъектам персональных данных, за исключением случаев, когда
                            имеются законные основания для раскрытия таких персональных
                            данных. Перечень информации и порядок ее получения установлен
                            Законом о персональных данных;
                        </div>
                        <div>
                            - требовать от Оператора уточнения его персональных данных, их
                            блокирования или уничтожения в случае, если персональные
                            данные являются неполными, устаревшими, неточными, незаконно
                            полученными или не являются необходимыми для заявленной цели
                            обработки, а также принимать предусмотренные законом меры по
                            защите своих прав;
                        </div>
                        <div>
                            - обжаловать в Роскомнадзоре или в судебном порядке
                            неправомерные действия или бездействие Оператора при обработке
                            его персональных данных.
                        </div>
                        <div>
                            Субъект персональных данных может реализовать права по
                            получению информации, касающейся обработки его персональных
                            данных, а также права по уточнению его персональных данных, их
                            блокированию или уничтожению, обратившись к Оператору с
                            соответствующим запросом по адресу: 108813, г. Москва, вн.
                            тер. г. муниципальный округ Филимонковский, г. Московский, ул.
                            Солнечная, д. 2А, стр. 2, этаж 2, ком. 210 или путем обращения
                            к Оператору с соответствующим запросом по электронной почте
                            {' '}
                            <MailLink />
                            . В обоих случаях запрос должен быть
                            оформлен с соблюдением требований статьи 7.1. настоящей
                            Политики.
                        </div>
                        <div>
                            1.6. Контроль за исполнением требований настоящей Политики
                            осуществляется уполномоченным лицом, ответственным за
                            организацию обработки персональных данных у Оператора.
                        </div>
                        <div>
                            1.7. Ответственность за нарушение требований законодательства
                            Российской Федерации и локальных актов Оператора в сфере
                            обработки и защиты персональных данных определяется в
                            соответствии с законодательством Российской Федерации.
                        </div>
                    </div>
                </p>
                <p>
                    <b>2. ПРИНЦИПЫ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
                </p>
                <p>
                    <div>
                        2.1. Обработка персональных данных осуществляется Оператором в
                        соответствии с требованиями законодательства Российской Федерации
                        и на основе следующих принципов:
                        <div>- законности и справедливой основы;</div>
                        <div>
                            - ограничения обработки персональных данных достижением
                            конкретных, заранее определённых и законных целей;
                        </div>
                        <div>
                            - недопущения обработки персональных данных, несовместимой с
                            целями сбора персональных данных;
                        </div>
                        <div>
                            - недопущения объединения баз данных, содержащих персональные
                            данные, обработка которых осуществляется в целях,
                            несовместимых между собой;
                        </div>
                        <div>
                            - обработки только тех персональных данных, которые отвечают
                            целям их обработки;
                        </div>
                        <div>
                            - соответствия содержания и объёма обрабатываемых персональных
                            данных заявленным целям обработки;
                        </div>
                        <div>
                            - недопущения обработки избыточных персональных данных по
                            отношению к заявленным целям их обработки;
                        </div>
                        <div>
                            - обеспечения точности, достаточности и актуальности
                            персональных данных по отношению к целям обработки
                            персональных данных;
                        </div>
                        <div>
                            - уничтожения либо обезличивания персональных данных по
                            достижении целей их обработки или в случае утраты
                            необходимости в достижении этих целей, при невозможности
                            устранения Оператором допущенных нарушений персональных
                            данных, если иное не предусмотрено федеральным законом.
                        </div>
                    </div>
                </p>
                <p>
                    <b>3. ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
                </p>
                <p>
                    <div>
                        3.1. Правовым основанием обработки персональных данных является
                        совокупность нормативных правовых актов, во исполнение которых и в
                        соответствии с которыми Оператор осуществляет обработку
                        персональных данных, в том числе:
                    </div>
                    <div>- Конституция Российской Федерации;</div>
                    <div>- Трудовой кодекс Российской Федерации;</div>
                    <div>- Гражданский Кодекс Российской Федерации;</div>
                    <div>- Налоговый кодекс Российской Федерации;</div>
                    <div>
                        - Федеральный закон от 6 декабря 2011 г. № 402-ФЗ «О бухгалтерском
                        учёте»;
                    </div>
                    <div>
                        - иные нормативные правовые акты, регулирующие отношения,
                        связанные с деятельностью Оператора.
                    </div>
                    <div>
                        3.2. Правовым основанием обработки персональных данных также
                        являются:
                    </div>
                    <div>- Устав Оператора;</div>
                    <div>- договоры, заключаемые с Субъектом персональных данных;</div>
                    <div>
                        - согласие Субъекта персональных данных на обработку персональных
                        данных.
                    </div>
                </p>
                <p>
                    <b>
                        4. ОБЪЕМ, КАТЕГОРИИ И УСЛОВИЯ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ,
                        КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ ПРИМЕНИТЕЛЬНО К ЗАЯВЛЕННЫМ
                        ЦЕЛЯМ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                    </b>
                </p>
                <p>
                    <div>
                        4.1. Обработка персональных данных ограничивается достижением
                        конкретных, заранее определенных и законных целей. Не допускается
                        обработка персональных данных, несовместимая с целями сбора
                        персональных данных. Обработке
                    </div>
                    <div>
                        4.2. Содержание и объем обрабатываемых персональных данных должны
                        соответствовать заявленным целям обработки, предусмотренным в
                        настоящем разделе. Обрабатываемые персональные данные не должны
                        быть избыточными по отношению к заявленным целям их обработки.
                        Персональные данные обрабатываются Оператором в целях:
                    </div>
                    <div>
                        - обеспечения соблюдения трудового законодательства РФ (содействие
                        работникам в трудоустройстве, получении образования и продвижении
                        по службе, обеспечение личной безопасности работников, контроль
                        количества и качества выполняемой работы и обеспечение сохранности
                        имущества, обеспечение соблюдения законов и иных нормативных
                        правовых актов)
                    </div>
                    <div>
                        - рассмотрения соискателя на вакантную должность и принятия
                        решения о приеме либо отказе в приеме на работу
                    </div>
                    <div> - обработки входящих заявок с Сайта </div>
                    <div> - ведения статистики посещений Сайта </div>
                    <div>
                        4.3. В соответствии с настоящей Политикой Оператор может
                        обрабатывать персональные данные, принадлежащих следующим
                        категориям Субъектов персональных данных:
                    </div>
                    <div>
                        - работникам Оператора и физическим лицам, оказывающим услуги или
                        выполняющим работы по гражданско-правовым договорам, или
                        физическим лицам-представителям таких оказывающих услуги
                        юридических лиц;
                    </div>
                    <div> - соискателям на вакантные места Оператора; </div>
                    <div> - посетителям Сайта Оператора </div>
                    <div>
                        <b>
                            4.4. Обработка персональных данных в целях обеспечения
                            соблюдения трудового законодательства РФ.
                        </b>
                    </div>
                    <div>
                        4.4.1. В соответствии с настоящим разделом Политики Оператор
                        определяет категории и перечень обрабатываемых персональных
                        данных, категории субъектов, персональные данные которых
                        обрабатываются, способы, сроки их обработки и хранения, порядок
                        уничтожения персональных данных при достижении цели их обработки
                        или при наступлении иных законных оснований применительно к такой
                        цели, как «обеспечение соблюдения трудового законодательства РФ (в
                        т.ч. содействие работникам в трудоустройстве, получении
                        образования и продвижении по службе, обеспечение личной
                        безопасности работников, контроль количества и качества
                        выполняемой работы и обеспечение сохранности имущества,
                        обеспечение соблюдения законов и иных нормативных правовых
                        актов)».
                    </div>
                    <div>
                        4.4.2. В указанной в настоящем разделе Политики цели Оператор
                        обрабатывает персональные данные, принадлежащие такой категории
                        субъектов персональных данных, как работники Оператора
                    </div>
                    <div>
                        4.4.3. Оператор обрабатывает следующие категории и перечень
                        персональных данных работников в указанной в настоящем разделе
                        Политики цели:
                    </div>
                    <div>
                        <div>
                            а) обработка общих (иных) категорий персональных данных
                            работников осуществляется в соответствии со следующим
                            перечнем:
                        </div>
                        <div>- фамилия, имя, отчество</div>
                        <div>- год рождения</div>
                        <div>- месяц рождения</div>
                        <div>- дата рождения</div>
                        <div>- место рождения</div>
                        <div>- семейное положение</div>
                        <div>- доходы</div>
                        <div>- пол</div>
                        <div>- адрес места жительства</div>
                        <div>- адрес регистрации</div>
                        <div>- адрес электронной почты</div>
                        <div>- номер телефона</div>
                        <div>- СНИЛС</div>
                        <div>- ИНН</div>
                        <div>- гражданство</div>
                        <div>- данные документа, удостоверяющего личность</div>
                        <div>- данные водительского удостоверения</div>
                        <div>- реквизиты банковской карты</div>
                        <div>- номер расчетного счета</div>
                        <div>- номер лицевого счета</div>
                        <div>- профессия</div>
                        <div>- должность</div>
                        <div>- стаж работы</div>
                        <div>
                            - отношение к воинской обязанности, сведения о воинском учете
                        </div>
                        <div>- сведения об образовании</div>
                        <div>- фотография</div>
                        <div>- свидетельство о рождении детей</div>
                    </div>
                    <div>
                        <div>
                            б) обработка специальных категорий персональных данных
                            работников осуществляется в соответствии с требованиями
                            законодательства Российской Федерации, а именно:
                        </div>
                        <div>- национальная принадлежность</div>
                        <div>- сведения о судимости</div>
                    </div>
                    <div>
                        <div>
                            в) обработка Оператором биометрических персональных данных
                            работников (сведений, которые характеризуют физиологические и
                            биологические особенности человека, на основании которых можно
                            установить его личность) осуществляется в соответствии с
                            требованиями законодательства Российской Федерации, а именно:
                        </div>
                        <div>
                            - данные изображения лица, полученные с помощью фото- видео
                            устройств
                        </div>
                    </div>
                    <div>
                        4.4.4. Оператор осуществляет смешанную обработку персональных
                        данных работников в указанной в настоящем разделе Политики цели с
                        передачей по внутренней сети, с передачей по сети интернет.
                    </div>
                    <div>
                        4.4.5. Перечень действий, совершаемых Оператором с персональными
                        данными работников в указанной в настоящем разделе Политики цели:
                        сбор, запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, удаление,
                        уничтожение.
                    </div>
                    <div>
                        4.4.6. Обработка персональных данных работников не требует
                        получения соответствующего согласия при условии, что объем
                        обрабатываемых Оператором персональных данных соответствует цели
                        по обеспечению соблюдения трудового законодательства РФ, указанной
                        в настоящем разделе Политики, на основании пункта 2 части 1 статьи
                        6 Закона о персональных данных.
                    </div>
                    <div>
                        4.4.7. При заключении трудового договора работники предоставляют
                        Оператору следующие документы, содержащие их персональные данные:
                    </div>
                    <div>- паспорт или иной документ, удостоверяющий личность;</div>
                    <div>
                        - трудовую книжку и (или) сведения о трудовой деятельности, за
                        исключением случаев, если трудовой договор заключается впервые;
                    </div>
                    <div>
                        - документ, подтверждающий регистрацию в системе индивидуального
                        (персонифицированного) учета, в том числе в форме электронного
                        документа;
                    </div>
                    <div>
                        - документы воинского учета - для военнообязанных и лиц,
                        подлежащих призыву на военную службу;
                    </div>
                    <div>
                        - документ об образовании и (или) о квалификации или наличии
                        специальных знаний - при поступлении на работу, требующую
                        специальных знаний или специальной подготовки;
                    </div>
                    <div>
                        - иные документы в соответствии с требованиями законодательства.
                    </div>
                    <div>
                        4.4.8. В случае первоначального заключения трудового договора с
                        работниками, трудовую книжку, страховое свидетельство
                        государственного пенсионного страхования оформляет Оператор.
                    </div>
                    <div>
                        4.4.9. В случае, если для трудоустройства работников требуются в
                        соответствии с законодательством иные документы, Оператор
                        обращается к лицам, поступающим на работу, с просьбой о
                        предоставлении таких документов, содержащих их персональные
                        данные.
                    </div>
                    <div>
                        4.4.10. Оператор осуществляет хранение персональных данных
                        работников в форме, позволяющей определить субъектов персональных
                        данных, не дольше, чем этого требуют указанная в настоящем разделе
                        Политики цель обработки персональных данных, если срок хранения
                        персональных данных не установлен федеральным законом.
                    </div>
                    <div>
                        4.4.11. Оператор обрабатывает персональные данные уволенных
                        работников в случаях и в сроки, предусмотренные законодательством
                        РФ. К таким случаям, в том числе, относится обработка персональных
                        данных в рамках бухгалтерского и налогового учета, в том числе для
                        обеспечения сохранности документов, необходимых для исчисления,
                        удержания и перечисления налога.
                    </div>
                    <div>
                        4.4.12. Оператор обязан хранить бухгалтерскую документацию в
                        течение сроков, устанавливаемых в соответствии с правилами
                        организации государственного архивного дела, но при этом
                        минимальный срок хранения не может быть менее 5 (пяти) лет.
                    </div>
                    <div>
                        4.4.13. По истечении сроков, определенных законодательством РФ,
                        личные дела работников и иные документы передаются на архивное
                        хранение на срок 50 лет.
                    </div>
                    <div>
                        4.4.14. Согласие работников на обработку их персональных данных в
                        случаях, предусмотренных пунктами 4.4.11. – 4.4.13. Политики, не
                        требуется.
                    </div>
                    <div>
                        4.4.15. Оператор без согласия работников не раскрывает третьим
                        лицам и не распространяет персональные данные работников в
                        указанной в настоящем разделе Политики цели, если иное не
                        предусмотрено законодательством РФ.
                    </div>
                    <div>
                        4.4.16. При передаче персональных данных работников Оператором
                        должны соблюдаться следующие требования:
                    </div>
                    <div>
                        - запрещается сообщать персональные данные работников третьей
                        стороне без письменного согласия работников, за исключением
                        случаев, когда это необходимо в целях предупреждения угрозы жизни
                        и здоровью работников, а также в случаях, установленных
                        действующим законодательством РФ;
                    </div>
                    <div>
                        - работник, передающий персональные данные работников Оператора,
                        обязан предупредить лиц, получающих персональные данные
                        работников, о том, что эти данные могут быть использованы лишь в
                        целях, для которых они сообщены, и требовать от этих лиц
                        подтверждения соблюдения этого правила. Лица, получающие
                        персональные данные работников Оператора, обязаны соблюдать режим
                        их конфиденциальности. Данное положение не распространяется на
                        обмен персональными данными работников в порядке, установленном
                        действующим законодательством РФ;
                    </div>
                    <div>
                        - работник, передающий персональные данные работников Оператора,
                        имеет право передавать их персональные данные представителям
                        работников в порядке, установленном Трудовым кодексом РФ, и
                        ограничивать эту информацию только теми персональными данными
                        работников, которые необходимы для выполнения указанными
                        представителями их функций.
                    </div>
                    <div>
                        - передача персональных данных работников в Фонд пенсионного и
                        социального страхования Российской Федерации (Социальный фонд
                        России) в порядке, установленном федеральными законами, в
                        частности Федеральным законом «Об обязательном пенсионном
                        страховании в Российской Федерации», Федеральным законом «Об
                        основах обязательного социального страхования», Федеральным
                        законом «Об обязательном медицинском страховании в Российской
                        Федерации» осуществляется без согласия работников.
                    </div>
                    <div>
                        - Согласие работников не требуется в случаях передачи Оператором
                        персональных данных работников в налоговые органы, военные
                        комиссариаты, профсоюзные органы, предусмотренных действующим
                        законодательством РФ, а также при получении, в рамках
                        установленных полномочий, мотивированных запросов от органов
                        прокуратуры, правоохранительных органов, органов безопасности, от
                        государственных инспекторов труда при осуществлении ими
                        государственного надзора и контроля за соблюдением трудового
                        законодательства и иных органов, уполномоченных запрашивать
                        информацию о работниках в соответствии с компетенцией,
                        предусмотренной действующим законодательством РФ.
                    </div>
                    <div>
                        <b>
                            4.5. Обработка персональных данных в целях рассмотрения
                            соискателя на вакантную должность и принятия решения о приеме
                            либо отказе в приеме на работу.
                        </b>
                    </div>
                    <div>
                        4.5.1. В соответствии с настоящим разделом Политики Оператор
                        определяет категории и перечень обрабатываемых персональных
                        данных, категории субъектов, персональные данные которых
                        обрабатываются, способы, сроки их обработки и хранения, порядок
                        уничтожения персональных данных при достижении цели их обработки
                        или при наступлении иных законных оснований применительно к такой
                        цели, как «рассмотрение соискателя на вакантную должность и
                        принятие решения о приеме либо отказе в приеме на работу».
                    </div>
                    <div>
                        4.5.2. В указанной в настоящем разделе Политики цели Оператор
                        обрабатывает персональные данные, принадлежащие такой категории
                        субъектов персональных данных, как соискатели на вакантные места
                        Оператора
                    </div>
                    <div>
                        4.5.3. Оператор обрабатывает следующие категории и перечень
                        персональных данных соискателей в указанной в настоящем разделе
                        Политики цели:
                    </div>
                    <div>
                        <div>
                            а) обработка общих (иных) категорий персональных данных
                            соискателей осуществляется в соответствии со следующим
                            перечнем:
                        </div>
                        <div>- фамилия, имя, отчество</div>
                        <div>- год рождения</div>
                        <div>- месяц рождения</div>
                        <div>- дата рождения</div>
                        <div>- место рождения</div>
                        <div>- семейное положение</div>
                        <div>- доходы</div>
                        <div>- пол</div>
                        <div>- адрес места жительства</div>
                        <div>- адрес электронной почты</div>
                        <div>- номер телефона</div>
                        <div>- гражданство</div>
                        <div>- профессия</div>
                        <div>- должность</div>
                        <div>- стаж работы</div>
                        <div>
                            - отношение к воинской обязанности, сведения о воинском учете
                        </div>
                        <div>- сведения об образовании</div>
                        <div>- фотография</div>
                    </div>
                    <div>
                        <div>
                            б) обработка специальных категорий персональных данных
                            соискателей осуществляется в соответствии с требованиями
                            законодательства Российской Федерации, а именно:
                        </div>
                        <div>- национальная принадлежность</div>
                        <div>- сведения о судимости</div>
                    </div>
                    <div>
                        <div>
                            в) обработка биометрических персональных данных соискателей
                            (сведений, которые характеризуют физиологические и
                            биологические особенности человека, на основании которых можно
                            установить его личность) осуществляется в соответствии с
                            требованиями законодательства Российской Федерации, а именно:
                        </div>
                        <div>
                            - данные изображения лица, полученные с помощью фото- видео
                            устройств
                        </div>
                    </div>
                    <div>
                        4.5.4. Оператор осуществляет смешанную обработку персональных
                        данных соискателей в указанной в настоящем разделе Политики цели с
                        передачей по внутренней сети, с передачей по сети интернет.
                    </div>
                    <div>
                        4.5.5. Перечень действий, совершаемых Оператором с персональными
                        данными соискателей в указанной в настоящем разделе цели: сбор,
                        запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, удаление,
                        уничтожение.
                    </div>
                    <div>
                        4.5.6. Обработка персональных данных соискателей в указанной в
                        настоящем разделе Политики цели осуществляется при условии
                        получения предварительного согласия на такую обработку. Получение
                        согласий от соискателей производится в случае приглашения на
                        собеседование.
                    </div>
                    <div>
                        4.5.7. Размещение соискателями на электронных интернет-ресурсах
                        (агрегаторах вакансий) производится в соответствии с правилами
                        данных ресурсов. Отправляя резюме на электронную почту Оператора,
                        соискатели тем самым дают согласие в конклюдентной форме на
                        обработку их персональных данных.
                    </div>
                    <div>
                        4.5.8. При проведении собеседований с соискателями персональные
                        данные, содержащиеся в анкетах и резюме, могут подтверждаться
                        документально. Копии подтверждающих документов могут храниться
                        Оператором, но не дольше чем до момента достижения целей их
                        обработки или утраты необходимости в достижении таких целей. После
                        достижения цели их обработки персональные данные соискателей
                        подлежат удалению в течение 30 дней.
                    </div>
                    <div>
                        4.5.9. Оператор без согласия субъекта персональных данных не
                        раскрывает третьим лицам и не распространяет персональные данные
                        соискателей в указанной в настоящем разделе Политики цели, если
                        иное не предусмотрено законодательством РФ.
                    </div>
                    <div>
                        <b>
                            4.6. Обработка персональных данных в целях обработки входящих
                            заявок с Сайта.
                        </b>
                    </div>
                    <div>
                        4.6.1. В соответствии с настоящим разделом Политики Оператор
                        определяет категории и перечень обрабатываемых персональных
                        данных, категории субъектов, персональные данные которых
                        обрабатываются, способы, сроки их обработки и хранения, порядок
                        уничтожения персональных данных при достижении цели их обработки
                        или при наступлении иных законных оснований применительно к такой
                        цели, как «обработка входящих заявок с Сайта».
                    </div>
                    <div>
                        4.6.2. В указанной в настоящем разделе Политики цели Оператор
                        обрабатывает персональные данные, принадлежащие такой категории
                        субъектов персональных данных, как посетители Сайта Оператора
                    </div>
                    <div>
                        4.6.3. Оператор обрабатывает следующие категории и перечень
                        персональных данных посетителей в указанной в настоящем разделе
                        Политики цели:
                    </div>
                    <div>
                        <div>
                            а) обработка общих (иных) категорий персональных данных
                            посетителей осуществляется в соответствии со следующим
                            перечнем:
                        </div>
                        <div>- имя Пользователя;</div>
                        <div>- фамилия Пользователя;</div>
                        <div>- отчество Пользователя;</div>
                        <div>- адрес электронной почты (e-mail) Пользователя;</div>
                        <div>- номер телефон.</div>
                    </div>
                    <div>
                        <div>
                            б) обработка специальных категорий персональных данных
                            посетителей не осуществляется;
                        </div>
                    </div>
                    <div>
                        <div>
                            в) обработка биометрических персональных данных посетителей
                            (сведений, которые характеризуют физиологические и
                            биологические особенности человека, на основании которых можно
                            установить его личность) не осуществляется.
                        </div>
                    </div>
                    <div>
                        4.6.4. Оператор осуществляет смешанную обработку персональных
                        данных посетителей в указанной в настоящем разделе Политики цели
                        без передачи по внутренней сети, с передачей по сети интернет.
                    </div>
                    <div>
                        4.6.5. Перечень действий, совершаемых Оператором с персональными
                        данными посетителей в указанной в настоящем разделе цели: сбор,
                        запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, блокирование,
                        удаление, уничтожение.
                    </div>
                    <div>
                        4.6.6. Обработка персональных данных посетителей в указанной в
                        настоящем разделе Политики цели осуществляется при условии
                        получения предварительного согласия на такую обработку.
                    </div>
                    <div>
                        4.6.7. Оператор без согласия субъекта персональных данных не
                        раскрывает третьим лицам и не распространяет персональные данные
                        посетителей в указанной в настоящем разделе Политики цели, если
                        иное не предусмотрено законодательством РФ.
                    </div>
                    <div>
                        <b>
                            4.7. Обработка персональных данных в целях ведения статистики
                            посещений Сайта.
                        </b>
                    </div>
                    <div>
                        4.7.1. В соответствии с настоящим разделом Политики Оператор
                        определяет категории и перечень обрабатываемых персональных
                        данных, категории субъектов, персональные данные которых
                        обрабатываются, способы, сроки их обработки и хранения, порядок
                        уничтожения персональных данных при достижении цели их обработки
                        или при наступлении иных законных оснований применительно к такой
                        цели, как «ведение статистики посещений Сайта».
                    </div>
                    <div>
                        4.7.2. В указанной в настоящем разделе Политики цели Оператор
                        обрабатывает персональные данные, принадлежащие такой категории
                        субъектов персональных данных, как посетители Сайта Оператора
                    </div>
                    <div>
                        4.7.3. Оператор обрабатывает следующие категории и перечень
                        персональных данных посетителей в указанной в настоящем разделе
                        Политики цели:
                    </div>
                    <div>
                        <div>
                            а) обработка общих (иных) категорий персональных данных
                            посетителей осуществляется в соответствии со следующим
                            перечнем:
                        </div>
                        <div>- сведения, собираемые посредством метрических программ</div>
                    </div>
                    <div>
                        <div>
                            б) обработка специальных категорий персональных данных
                            посетителей не осуществляется;
                        </div>
                    </div>
                    <div>
                        <div>
                            в) обработка биометрических персональных данных посетителей
                            (сведений, которые характеризуют физиологические и
                            биологические особенности человека, на основании которых можно
                            установить его личность) не осуществляется.
                        </div>
                    </div>
                    <div>
                        4.7.4. Оператор осуществляет смешанную обработку персональных
                        данных посетителей в указанной в настоящем разделе Политики цели
                        без передачи по внутренней сети, с передачей по сети интернет.
                    </div>
                    <div>
                        4.7.5. Перечень действий, совершаемых Оператором с персональными
                        данными посетителей в указанной в настоящем разделе цели: сбор,
                        запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, удаление,
                        уничтожение.
                    </div>
                    <div>
                        4.7.6. Обработка персональных данных посетителей в указанной в
                        настоящем разделе Политики цели осуществляется при условии
                        получения предварительного согласия на такую обработку.
                    </div>
                    <div>
                        4.7.7. Оператор без согласия субъекта персональных данных не
                        раскрывает третьим лицам и не распространяет персональные данные
                        посетителей в указанной в настоящем разделе Политики цели, если
                        иное не предусмотрено законодательством РФ.
                    </div>
                    <div>
                        4.7.8. На Сайте
                        {' '}
                        <LinkToSite />
                        . применяется сервис для
                        анализа посещаемости сайтов –Яндекс.Метрика от ООО «Яндекс» (далее
                        – «Яндекс»). Данный сервис использует так называемые «cookie»
                        («куки»): текстовые файлы, которые сохраняются на компьютере
                        пользователя и позволяют анализировать использование им Сайта.
                    </div>
                    <div>
                        4.7.9. Информация об использовании Сайта, сгенерированная с
                        помощью файла «cookie» (включая IP-адрес пользователя, дату и
                        время посещения сайта, типы браузера и операционной системы, тип и
                        модель мобильного устройства), может отправляться, в том числе, на
                        серверы Яндекс.
                    </div>
                    <div>
                        4.7.10. Яндекс на основании соглашений с ООО «Кибер Форм Системс»
                        обрабатывает полученную информацию для анализа использования
                        Сайта, составления отчетов об активности посетителей и оказания
                        ООО «Кибер Форм Системс» других услуг, связанных с использованием
                        Сайта и Интернета.
                    </div>
                    <div>
                        4.7.11. В подавляющем большинстве случаев сопоставление получаемых
                        данных с конкретным лицом невозможно, и такая цель не ставится.
                        Получаемые данные обрабатываются только с целью анализа
                        эффективности веб-ресурса (скорость загрузки, маршрут
                        пользователей), оценки медийных, поисковых и социальных рекламных
                        каналов; анализа конверсии и адаптации Сайта к бизнес-целям, а
                        также оценки количества «мобильного» трафика. Никакой другой
                        анализ данных не производится, кроме обработки для получения
                        статистических сведений со строгим соблюдением условий
                        конфиденциальности и анонимности.
                    </div>
                    <div>
                        4.7.12. Сведения о том, как отключить сбор сведений о Пользователе
                        с использованием сервиса Яндекс.Метрика, приведены на сайте
                        соответствующей компании.
                    </div>
                    <div>
                        <b>
                            4.8. Обработка персональных данных в целях заключения
                            гражданско-правовых договоров
                        </b>
                    </div>
                    <div>
                        4.8.1. В указанной в настоящем разделе Политики цели Оператор
                        обрабатывает персональные данные, принадлежащие такой категории
                        субъектов персональных данных, как физические лица, оказывающие
                        услуги или выполняющие работы по гражданско-правовым договорам,
                        или физические лица-представители таких оказывающих услуги
                        юридических лиц (далее – исполнители).
                    </div>
                    <div>
                        4.8.2. Оператор обрабатывает следующие категории и перечень
                        персональных данных работников в указанной в настоящем разделе
                        Политики цели:
                    </div>
                    <div>
                        <div>
                            а) обработка общих (иных) категорий персональных данных
                            работников осуществляется в соответствии со следующим
                            перечнем:
                        </div>
                        <div>- фамилия, имя, отчество</div>
                        <div>- год рождения</div>
                        <div>- месяц рождения</div>
                        <div>- дата рождения</div>
                        <div>- место рождения</div>
                        <div>- пол</div>
                        <div>- адрес места жительства</div>
                        <div>- адрес регистрации</div>
                        <div>- адрес электронной почты</div>
                        <div>- номер телефона</div>
                        <div>- СНИЛС</div>
                        <div>- ИНН</div>
                        <div>- гражданство</div>
                        <div>- данные документа, удостоверяющего личность</div>
                        <div>- данные водительского удостоверения</div>
                        <div>- реквизиты банковской карты</div>
                        <div>- номер расчетного счета</div>
                        <div>- номер лицевого счета</div>
                        <div>- сведения об образовании</div>
                        <div>- фотография</div>
                    </div>
                    <div>
                        4.8.3. Оператор осуществляет смешанную обработку персональных
                        данных в указанной в настоящем разделе Политики цели с передачей
                        по внутренней сети, с передачей по сети интернет.
                    </div>
                    <div>
                        4.8.4. Перечень действий, совершаемых Оператором с персональными
                        данными в указанной в настоящем разделе Политики цели: сбор,
                        запись, систематизация, накопление, хранение, уточнение
                        (обновление, изменение), извлечение, использование, удаление,
                        уничтожение.
                    </div>
                    <div>
                        4.8.5. При заключении гражданско-правового договора работники
                        предоставляют Оператору следующие документы, содержащие их
                        персональные данные:
                    </div>
                    <div>- паспорт или иной документ, удостоверяющий личность;</div>
                    <div>
                        - документ об образовании и (или) о квалификации или наличии
                        специальных знаний - при поступлении на работу, требующую
                        специальных знаний или специальной подготовки;
                    </div>
                    <div>
                        - иные документы в соответствии с требованиями законодательства;
                    </div>
                    <div>
                        - страховое свидетельство государственного пенсионного
                        страхования.
                    </div>
                    <div>
                        4.8.6. Оператор осуществляет хранение персональных данных в форме,
                        позволяющей определить субъектов персональных данных, не дольше,
                        чем этого требуют указанная в настоящем разделе Политики цель
                        обработки персональных данных, если срок хранения персональных
                        данных не установлен федеральным законом.
                    </div>
                    <div>
                        4.8.7. Оператор обрабатывает персональные данные в случае
                        расторжения договора в случаях и в сроки, предусмотренные
                        законодательством РФ. К таким случаям, в том числе, относится
                        обработка персональных данных в рамках бухгалтерского и налогового
                        учета, в том числе для обеспечения сохранности документов,
                        необходимых для исчисления, удержания и перечисления налога.
                    </div>
                    <div>
                        4.8.8. Оператор обязан хранить бухгалтерскую документацию в
                        течение сроков, устанавливаемых в соответствии с правилами
                        организации государственного архивного дела, но при этом
                        минимальный срок хранения не может быть менее 5 (пяти) лет.
                    </div>
                    <div>
                        4.8.9. Согласие работников на обработку их персональных данных в
                        случаях, предусмотренных пунктами 4.8.7. – 4.8.8. Политики, не
                        требуется.
                    </div>
                    <div>
                        4.8.10. Оператор без согласия субъекта персональных данных не
                        раскрывает третьим лицам и не распространяет персональные данные
                        работников в указанной в настоящем разделе Политики цели, если
                        иное не предусмотрено законодательством РФ.
                    </div>
                    <div>
                        4.8.11. При передаче персональных данных Оператором должны
                        соблюдаться следующие требования:
                    </div>
                    <div>
                        - запрещается сообщать персональные данные третьей стороне без
                        письменного согласия субъекта персональных данных, за исключением
                        случаев, когда это необходимо в целях предупреждения угрозы жизни
                        и здоровью субъекта персональных данных, а также в случаях,
                        установленных действующим законодательством РФ;
                    </div>
                    <div>
                        - сотрудник Оператора, передающий персональные данные, обязан
                        предупредить лиц, получающих персональные данные, о том, что эти
                        данные могут быть использованы лишь в целях, для которых они
                        сообщены, и требовать от этих лиц подтверждения соблюдения этого
                        правила. Лица, получающие персональные данные, обязаны соблюдать
                        режим их конфиденциальности. Данное положение не распространяется
                        на обмен персональными данными в порядке, установленном
                        действующим законодательством РФ;
                    </div>
                    <div>
                        - Согласие субъектов персональных данных не требуется в случаях
                        передачи Оператором персональных данных в налоговые органы, а
                        также при получении, в рамках установленных полномочий,
                        мотивированных запросов от органов прокуратуры, правоохранительных
                        органов, органов безопасности, и иных органов, уполномоченных
                        запрашивать информацию о работниках в соответствии с компетенцией,
                        предусмотренной действующим законодательством РФ.
                    </div>
                </p>
                <p>
                    <b>5. ПОРЯДОК СБОРА И ХРАНЕНИЯ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
                </p>
                <p>
                    <div>
                        5.1. При сборе персональных данных, в том числе посредством
                        информационно-телекоммуникационной сети Интернет, Оператор
                        обеспечивает запись, систематизацию, накопление, хранение,
                        уточнение (обновление, изменение), извлечение персональных данных
                        граждан Российской Федерации с использованием баз данных,
                        находящихся на территории Российской Федерации.
                    </div>
                    <div>
                        5.2. Лица, передавшие Оператору сведения о другом Субъекте
                        персональных данных, в том числе через Сайт, не имея при этом
                        согласия субъекта, чьи персональные данные были переданы, несут
                        ответственность в соответствии с законодательством Российской
                        Федерации.
                    </div>
                    <div>
                        5.3. Оператор осуществляет хранение персональных данных в форме,
                        позволяющей определить субъекта персональных данных, не дольше,
                        чем этого требуют цели обработки персональных данных, если срок
                        хранения персональных данных не установлен федеральным законом,
                        договором, стороной которого, выгодоприобретателем или поручителем
                        по которому является Субъект персональных данных.
                    </div>
                    <div>
                        5.4. Обрабатываемые персональные данные подлежат уничтожению в
                        случае:
                    </div>
                    <div> - достижения срока обработки персональных данных; </div>
                    <div> - достижения целей обработки персональных данных; </div>
                    <div>
                        - утраты необходимости в достижении целей обработки персональных
                        данных;
                    </div>
                    <div>
                        - получения отзыва согласия на обработку персональных данных;
                    </div>
                    <div>
                        - исключения Оператора из Единого государственного реестра
                        юридических лиц.
                    </div>
                </p>
                <p>
                    <b>6. ЗАЩИТА ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
                </p>
                <p>
                    <div>
                        6.1. Оператор принимает необходимые правовые, организационные и
                        технические меры для защиты персональных данных от неправомерного
                        или случайного доступа к ним, уничтожения, изменения,
                        блокирования, распространения и других несанкционированных
                        действий, в том числе:
                    </div>
                    <div>
                        - определяет угрозы безопасности персональных данных при их
                        обработке;
                    </div>
                    <div>
                        - принимает локальные нормативные акты и иные документы,
                        регулирующие отношения в сфере обработки и защиты персональных
                        данных;
                    </div>
                    <div>
                        - назначает лиц, ответственных за обеспечение безопасности
                        персональных данных в структурных подразделениях и информационных
                        системах Оператора;
                    </div>
                    <div>
                        - создает необходимые условия для работы с персональными данными;
                    </div>
                    <div>
                        - организует учет документов, содержащих персональные данные;
                    </div>
                    <div>
                        - организует работу с информационными системами, в которых
                        обрабатываются персональные данные;
                    </div>
                    <div>
                        - хранит персональные данные в условиях, при которых
                        обеспечивается их сохранность и исключается неправомерный доступ к
                        ним;
                    </div>
                    <div>
                        - организует обучение работников Оператора, осуществляющих
                        обработку персональных данных.
                    </div>
                </p>
                <p>
                    <b>
                        7. АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ И УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ
                        ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП К ПЕРСОНАЛЬНЫМ
                        ДАННЫМ
                    </b>
                </p>
                <p>
                    <div>
                        7.1. Подтверждение факта обработки персональных данных Оператором,
                        правовые основания и цели обработки персональных данных, а также
                        иные сведения, указанные в части 7 статьи 14 Закона о персональных
                        данных, предоставляются Оператором Субъекту персональных данных
                        или его представителю при обращении либо при получении запроса
                        Субъекта персональных данных или его представителя в течение 10
                        (десяти) рабочих дней с момента поступления обращения или
                        получения запроса. В предоставляемые сведения не включаются
                        персональные данные, относящиеся к другим Субъектам персональных
                        данных, за исключением случаев, когда имеются законные основания
                        для раскрытия таких персональных данных.
                    </div>
                    <div> Запрос должен содержать: </div>
                    <div>
                        - номер основного документа, удостоверяющего личность Субъекта
                        персональных данных или его представителя, сведения о дате выдачи
                        указанного документа и выдавшем его органе;
                    </div>
                    <div>
                        - сведения, подтверждающие участие Субъекта персональных данных в
                        отношениях с Оператором (номер договора, дата заключения договора,
                        условное словесное обозначение и (или) иные сведения), либо
                        сведения, иным образом подтверждающие факт обработки персональных
                        данных Оператором;
                    </div>
                    <div>
                        - подпись Субъекта персональных данных или его представителя.
                    </div>
                    <div>
                        Запрос может быть направлен в форме электронного документа и
                        подписан электронной подписью в соответствии с законодательством
                        Российской Федерации.
                    </div>
                    <div>
                        Если в обращении (запросе) Субъекта персональных данных не
                        отражены в соответствии с требованиями Закона о персональных
                        данных все необходимые сведения или субъект не обладает правами
                        доступа к запрашиваемой информации, то ему направляется
                        мотивированный отказ.
                    </div>
                    <div>
                        Право Субъекта персональных данных на доступ к его персональным
                        данным может быть ограничено в соответствии с частью 8 статьи 14
                        Закона о персональных данных, в том числе если доступ Субъекта
                        персональных данных к его персональным данным нарушает права и
                        законные интересы третьих лиц.
                    </div>
                    <div>
                        7.2. В случае выявления неточных персональных данных при обращении
                        Субъекта персональных данных или его представителя либо по их
                        запросу или по запросу Роскомнадзора Оператор осуществляет
                        блокирование персональных данных, относящихся к этому Субъекту
                        персональных данных, с момента такого обращения или получения
                        указанного запроса на период проверки, если блокирование
                        персональных данных не нарушает права и законные интересы Субъекта
                        персональных данных или третьих лиц.
                    </div>
                    <div>
                        В случае подтверждения факта неточности персональных данных
                        Оператор на основании сведений, представленных субъектом
                        персональных данных или его представителем либо Роскомнадзором,
                        или иных необходимых документов уточняет персональные данные в
                        течение семи рабочих дней со дня представления таких сведений и
                        снимает блокирование персональных данных.
                    </div>
                    <div>
                        7.3. В случае выявления неправомерной обработки персональных
                        данных при обращении (запросе) Субъекта персональных данных или
                        его представителя либо Роскомнадзора Оператор осуществляет
                        блокирование неправомерно обрабатываемых персональных данных,
                        относящихся к этому Субъекту персональных данных, с момента такого
                        обращения или получения запроса.
                    </div>
                    <div>
                        7.4. При достижении целей обработки персональных данных, а также в
                        случае отзыва Субъектом персональных данных согласия на их
                        обработку персональные данные подлежат уничтожению, если:
                    </div>
                    <div>
                        - иное не предусмотрено договором, стороной которого является
                        Субъект персональных данных;
                    </div>
                    <div>
                        - оператор не вправе осуществлять обработку без согласия Субъекта
                        персональных данных на основаниях, предусмотренных Законом о
                        персональных данных или иными федеральными законами;
                    </div>
                    <div>
                        - иное не предусмотрено другим соглашением между Оператором и
                        Субъектом персональных данных.
                    </div>
                </p>
                <p>
                    <b>8. ЗАКЛЮЧИТЕЛЬНИЕ ПОЛОЖЕНИЯ</b>
                </p>
                <p>
                    <div>
                        8.1. Во исполнение требований части 2 статьи 18.1 Закона о
                        персональных данных настоящая Политика размещается по адресу
                        местонахождения Оператора, а также в свободном доступе в
                        информационно-телекоммуникационной сети «Интернет» на Сайте с
                        адресом:
                        {' '}
                        <LinkToSite />
                        .
                    </div>
                </p>
            </BlockContent>

            <BigFeedback />
        </>
    );
};
